import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';
import { LoaderButton } from 'ctia-ui';
import { notifyMessages } from 'helpers/NotifyHelper';
import { submitInitialRequest } from 'actions/request';
import { submitWizard, saveWizard } from 'actions/wizard';
import { signAgreement, getAgreementInfo } from 'actions/agreement';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';

class AgreementsControls extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSaving: false,
      isSubmitting: false
    };
  }

  startSaving() {
    this.setState({ isSaving: true });
  }

  stopSaving() {
    this.setState({ isSaving: false });
  }

  startSubmitting() {
    this.setState({ isSubmitting: true });
  }

  stopSubmitting() {
    this.setState({ isSubmitting: false });
  }

  errorMessageCallback = message => {
    this.stopSaving();
    this.stopSubmitting();
    this.props.showNotice(message);
  };

  onSave = () => {
    // activate button preloader
    this.startSaving();

    const { request, submitInitialRequest, saveWizard } = this.props;

    submitInitialRequest(request, saveWizard);
  };

  onSubmit = () => {
    // activate button preloader
    this.startSubmitting();

    const { request, submitInitialRequest, submitWizard } = this.props;

    submitInitialRequest(request, submitWizard);
  };

  acceptAgreement = () => {
    const {
      startPreloader,
      signAgreement,
      request,
      getAgreementInfo
    } = this.props;
    const modelId = request.model.id;
    startPreloader();
    signAgreement(modelId)
      .catch(() => this.errorMessageCallback(notifyMessages.cantSignAgreement))
      .then(() => getAgreementInfo(modelId))
      .then(() =>
        this.errorMessageCallback(notifyMessages.requestUpdatedSuccessfully)
      );
  };

  render() {
    const { request, user } = this.props;
    const accepted = request.agreementAccepted;
    const { isSaving, isSubmitting } = this.state;
    const disabledState = !accepted || isSaving || isSubmitting;

    if (request.id > 0) {
      return (
        <div className="text-right">
          <LoaderButton
            bsStyle="default"
            text="Save changes"
            disabled={!accepted}
            isLoading={isSaving}
            onClick={this.acceptAgreement}
            show={request.isSaved && user.isVendor}
          />
        </div>
      );
    }

    return (
      <div>
        <Col xs={6} className="text-left">
          <LoaderButton
            disabled={accepted}
            text="Save request"
            isLoading={isSaving}
            onClick={this.onSave}
          />
        </Col>
        <Col xs={6} className="text-right">
          <LoaderButton
            disabled={disabledState}
            bsStyle="success"
            text="Submit request"
            isLoading={isSubmitting}
            onClick={this.onSubmit}
          />
        </Col>
      </div>
    );
  }
}

function mapStateToProps({ request, wizard, user }) {
  return { request, wizard, user };
}

export default connect(
  mapStateToProps,
  {
    saveWizard,
    submitWizard,
    signAgreement,
    startPreloader,
    finishPreloader,
    showNotice,
    getAgreementInfo,
    submitInitialRequest
  }
)(AgreementsControls);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Agreements/AgreementsControls.js